<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 19 14" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M13.0718 7C13.0718 8.71822 11.6789 10.1111 9.96068 10.1111C8.24246 10.1111 6.84957 8.71822 6.84957 7C6.84957 5.28178 8.24246 3.88889 9.96068 3.88889C11.6789 3.88889 13.0718 5.28178 13.0718 7ZM11.5162 7C11.5162 7.85911 10.8198 8.55556 9.96068 8.55556C9.10157 8.55556 8.40512 7.85911 8.40512 7C8.40512 6.14089 9.10157 5.44444 9.96068 5.44444C10.8198 5.44444 11.5162 6.14089 11.5162 7Z"
            :fill=" color ? color : '#FCC210'" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M9.96068 0C14.3096 0 17.9639 2.97447 19 7C17.9639 11.0255 14.3096 14 9.96068 14C5.61172 14 1.95749 11.0255 0.921387 7C1.95749 2.97447 5.61172 0 9.96068 0ZM9.96068 12.4444C6.47968 12.4444 3.52948 10.1563 2.53853 7C3.52948 3.84367 6.47968 1.55556 9.96068 1.55556C13.4417 1.55556 16.3919 3.84367 17.3828 7C16.3919 10.1563 13.4417 12.4444 9.96068 12.4444Z"
            :fill=" color ? color : '#FCC210'"  />
    </svg>
</template>

<script>
export default {
    props: {
        color: String
    },
    name: 'Eyecomponent'
}
</script>

<style lang="scss" scoped></style>